export default "__VITE_ASSET__4F0q$l7R__"